import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
   return (
      <>
         <h1>in development process</h1>
         <Link to="/">back to home</Link>
      </>
   );
}

export default NotFound;
